import { corePages } from './core';
import { troubleshootingPages } from './troubleshooting';
import { comparisonPages } from './comparison';
import { safetyPages } from './safety';
import { trustPages } from './trust';
export { pagesMeta } from './pages-meta';

export const allPages = {
  ...corePages,
  ...troubleshootingPages,
  ...comparisonPages,
  ...safetyPages,
  ...trustPages,
};

export function getPageContent(key) {
  return allPages[key] || null;
}
